import React, { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import InnerLoader from "../Shared/Loader/InnerLoader";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import Scrollable from "../Shared/Edit/Scrollable";
import { useTranslation } from "react-i18next";

const StatesRules = ({ roles, onClose, save, updateData, formFields, defaultFormFields }) => {

    const { t } = useTranslation([
        "attribute/state_field",
    ]);

    const uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    const [states, setStates] = useState(formFields.statefield.filter((option) => option.name.trim() !== ""));
    const [savingRules, setSavingRules] = useState(false);
    const [rules, setRules] = useState(formFields.rules.length === 0 ? [
        {
            fromStateId: "",
            toStateId: "",
            roleIds: [],
            order: 10000000000,
            _id: uuidv4(),
        }
    ] : formFields.rules);
    
    const [allowOnlyTransitionConfigurations, setAllowOnlyTransitionConfigurations] = useState(formFields.allowOnlyTransitionConfigurations);

    const getFromStateValue = (fromStateId) => {
        debugger
        return states.find(state => state._id === fromStateId) || {};
    }

    const getToStateValue = (toStateId) => {
        return states.find(state => state._id === toStateId) || {};
    }

    const handleRuleChange = (event, dataItem) => {
        debugger
        const selectedRuleId = dataItem._id;
        let { name, value } = event.target;
        if (name === "roleIds") {
            value = value.map(role => role._id);
        } else {
            value = value._id;
        }
        const newRules = rules.map((rule) => {
            if (rule._id === selectedRuleId) {
                return {
                    ...rule,
                    [name]: value
                }
            }
            return rule;
        });
        newRules.forEach((rule, index) => rule.hasSameRule = hasSameRule(rule, index, newRules));
        setRules(newRules);
    }

    const hasSameRule = (rule, index, newRules) => {
        return newRules.some((r, ruleIndex) => r.fromStateId === rule.fromStateId && r.toStateId === rule.toStateId && index !== ruleIndex);
    }

    const saveRules = async (e) => {
        try {
            debugger
            e.preventDefault();
            setSavingRules(true);
            await saveStates();
            const mappedRules = rules
                .filter(rule => rule.fromStateId && rule.toStateId && rule.roleIds.length > 0)
                .map(rule => ({
                    _id: rule._id,
                    fromStateId: rule.fromStateId,
                    toStateId: rule.toStateId,
                    order: rule.order,
                    roleIds: rule.roleIds,
                }));

            const filteredRules = [...mappedRules]
                .filter(rule => rule._id)
                .sort((a, b) => a.order - b.order)
                .filter((rule, index, self) => index === self.findIndex((t) => t._id === rule._id));

            setRules(filteredRules);
            updateData("rules", filteredRules);
            updateData("allowOnlyTransitionConfigurations", allowOnlyTransitionConfigurations);
            await save();
            onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setSavingRules(false);
        }
    };

    const saveStates = async () => {
        try {
            const trimmedStates = states.filter(state => state.name.trim().length > 0).map((state, index) => {
                state.name = state.name.trim();
                state.order = parseInt((index + 1) * 10000000000);
                return state;
            });

            const newStates = [...trimmedStates]
                .filter(state => state._id)
                .sort((a, b) => a.order - b.order)
                .filter((state, index, self) => index === self.findIndex((t) => t._id === state._id));

            setStates(newStates);
            updateData("statefield", newStates);
        } catch (error) {
            console.error(error);
        }
    }

    const isSaveDisabled = () => {
        if (savingRules) {
            return true;
        }

        if (defaultFormFields.rules.length === 0 && rules.length === 0) {
            return true;
        }

        let isAnyRuleInvalid = rules.some(rule => (
            !rule.fromStateId ||
            !rule.toStateId ||
            rule.roleIds.length === 0 ||
            rule.hasSameRule ||
            rule.fromStateId === rule.toStateId
        ));
        if (isAnyRuleInvalid) {
            return true;
        }

        if (rules.length !== defaultFormFields.rules.length) {
            return false;
        }

        const ruleChanged = rules.some((rule, index) => {
            const defaultRule = defaultFormFields.rules[index];
            return (
                rule.fromStateId !== defaultRule.fromStateId ||
                rule.toStateId !== defaultRule.toStateId ||
                rule.roleIds.length !== defaultRule.roleIds.length ||
                rule.roleIds.some((roleId, roleIndex) => {
                    return roleId !== defaultRule.roleIds[roleIndex];
                })
            );
        }) || defaultFormFields.allowOnlyTransitionConfigurations !== allowOnlyTransitionConfigurations;
        return !ruleChanged;
    }

    const isAnyDuplicateRules = () => {
        const hasDuplicate = rules.some(rule => rule.hasSameRule);
        const hasSameFromAndToState = rules.some(rule => {
            if (rule.fromStateId && rule.toStateId) {
                return rule.fromStateId === rule.toStateId;
            }
            return false;
        });

        return hasDuplicate || hasSameFromAndToState;
    };

    const getRolesSortedAlphabetically = (roles) => {
        return roles.sort((a, b) => a.roleName.localeCompare(b.roleName));
    }

    return (
        <Dialog
            width={`80%`}
            height={`80%`}
            title={`${t("title")} - ${formFields.attributeName}`}
            onClose={onClose}
        >
            <Scrollable>
                {savingRules && <OverlayLoader />}
                <div className="row my-3">
                    <div className="col-12 mb-3">
                        <div className="row">
                            <div className="col-3">
                                {t("from_state")}
                            </div>
                            <div className="col-3">
                                {t("to_state")}
                            </div>
                            <div className="col-5">
                                {t("roles")}
                            </div>
                        </div>
                    </div>
                    {rules.map((rule, index) => (
                        <div className="col-12 mb-2" key={index}>
                            <div className="row">
                                <div className="col-3 mb-3">
                                    <DropDownList
                                        className={rule.hasSameRule ? 'border-danger is-invalid' : ''}
                                        name="fromStateId"
                                        textField="name"
                                        data={states}
                                        dataItemKey="_id"
                                        onChange={(event) => handleRuleChange(event, rule)}
                                        value={getFromStateValue(rule.fromStateId)}
                                    />
                                </div>
                                <div className="col-3 mb-3">
                                    <DropDownList
                                        className={rule.hasSameRule ? 'border-danger is-invalid' : ''}
                                        name="toStateId"
                                        textField="name"
                                        data={states}
                                        dataItemKey="_id"
                                        onChange={(event) => { handleRuleChange(event, rule) }}
                                        value={getToStateValue(rule.toStateId)}
                                    />
                                </div>
                                <div className="col-5 position-relative custom-tag">
                                    <MultiSelect
                                        name="roleIds"
                                        textField="roleName"
                                        className="form-control-custom"
                                        data={getRolesSortedAlphabetically(roles)}
                                        onChange={(event) => handleRuleChange(event, rule)}
                                        value={getRolesSortedAlphabetically(rule.roleIds.map(roleId => roles.find(role => role._id === roleId))).filter(role => role)}
                                        placeholder={t("select_roles_placeholder")}
                                    />
                                </div>
                                <div className="col-1 d-flex align-items-center">
                                    <i className="fa fa-times pointer" onClick={() => {
                                        const newRules = rules.filter((r, i) => i !== index);
                                        setRules(newRules);
                                    }}></i>
                                </div>
                            </div>
                        </div>
                    ))}
                    {isAnyDuplicateRules() && (
                        <div className="col-12">
                            <span className="text-danger">
                                {t("errors.duplicate_rules")}
                            </span>
                        </div>
                    )}
                </div>
                <button
                    type="button"
                    className="btn p-2 hover-bg-7 hover-border-0 form-label d-inline-block t-primary pointer"
                    onClick={() => setRules([
                        ...rules,
                        {
                            fromStateId: "",
                            toStateId: "",
                            roleIds: [],
                            order: rules.length > 0 ? parseInt((rules[rules.length - 1]["order"]) + 10000000000) : 10000000000,
                            _id: uuidv4()
                        }
                    ])}
                >
                    <i className="me-1 fa fa-plus"></i>
                    {t("add_rule")}
                </button>
            </Scrollable>
            <DialogActionsBar layout="end">
                <div className="m-3">
                    <small className="mt-1">
                        {savingRules && (
                            <div className="d-inline-block">
                                <InnerLoader borderColor="green" />
                                <span className="me-4 text-success"></span>
                            </div>
                        )}
                    </small>
                    <button className="btn btn-secondary" onClick={onClose}>
                        {t("buttons.cancel")}
                    </button>
                    <button disabled={isSaveDisabled()} className="btn btn-primary" onClick={saveRules}>
                        {t("buttons.save")}
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}

export default StatesRules;